export const GET_DATA = 'GET_DATA';
export const CLEAR_DATA = 'CLEAR_DATA';
